import { Grid, TextField, Box, FormControlLabel, Switch } from '@mui/material';
import { Field } from 'formik';
import { TenantSelectIfAdmin } from '../../../../shared/components/SelectsDinamycs/TenantSelectIfAdmin';
import { useTenant } from '../../../../shared/context/TenantContext';

interface RoomFormFieldsProps {
  values: any;
  errors: any;
  touched: any;
  isAdmin: boolean;
  isSubmitting: boolean;
  setFieldValue: (field: string, value: any) => void;
}

export function RoomFormFields({ 
  values, 
  errors, 
  touched, 
  isAdmin, 
  isSubmitting,
  setFieldValue 
}: RoomFormFieldsProps) {
  const { selectedTenant, handleSetSelectedTenant } = useTenant();

  return (
    <Grid container spacing={2} mb={3}>
      <Grid item xs={12}>
        <Field
          as={TextField}
          fullWidth
          label="Nome da Sala"
          name="name"
          required
          disabled={isSubmitting}
          error={!!(touched.name && errors.name)}
          helperText={touched.name && errors.name}
          placeholder="Ex: Sala de Reuniões"
        />
      </Grid>
      <Grid item xs={12}>
        <Field
          as={TextField}
          fullWidth
          label="Descrição"
          name="description"
          multiline
          rows={3}
          disabled={isSubmitting}
          error={!!(touched.description && errors.description)}
          helperText={touched.description && errors.description}
          placeholder="Descreva os equipamentos e características da sala"
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Field name="virtualKey">
              {({ field }: { field: any }) => (
                <Switch
                  {...field}
                  checked={field.value}
                  color="primary"
                  disabled={isSubmitting}
                />
              )}
            </Field>
          }
          label="Habilitar área para chave virtual"
        />
      </Grid>
      {isAdmin && (
        <Grid item xs={12}>
          <Box sx={{ mb: 3 }}>
            <TenantSelectIfAdmin
              value={selectedTenant}
              onChange={(value) => {
                handleSetSelectedTenant(value);
                setFieldValue('tenantId', value);
              }}
              disabled={isSubmitting}
            />
          </Box>
        </Grid>
      )}
    </Grid>
  );
} 